/**
 * Type de datasource
 */
export enum DataSourceType {
  None = 'None',
  Family = 'Family',
  Contact = 'Contact',
  AzureAD = 'AzureAD',
}
